/*
 * 主题级 SVG 图标可访问名修复（重复 id="title"）——子需求 07
 *
 * 现象（审计实测）：主题 21 个文件共 319 处 `<title id="title">`，且都与所在 <svg aria-labelledby="title"> 成对
 * （仅 icon.liquid + icon-pack.liquid 就有 222 处），于是**同一页面里出现大量重复 id**：
 *   - HTML 不合法；更严重的是 `aria-labelledby` 是**文档级**查找 → 每个图标的可访问名都取"页面里第一个
 *     `<title id="title">`"，读屏会念错名字（实测 id="title" 在集合页重复 25 次）。
 *
 * 为什么不在 Liquid 里直接去掉 id：这 319 处都靠 `id="title"` 提供可访问名，删 id 会把 aria-labelledby 打断
 * （实测每个文件里都存在该配对）。真正的源头根治需要给**每个图标实例**分配唯一 id（涉及全部调用点），
 * 因此本次先用运行时修复：把每个 `<svg aria-labelledby="title">` 的标题 id 唯一化，并同步它自己的 aria-labelledby。
 *
 * 作用范围：**全站**（`layout/theme.liquid` 加载）——覆盖主题 21 个文件、319 处 `<title id="title">`
 * （含此前只在集合页覆盖不到的 19 个文件、以及页面模板里的内联 SVG）。
 * 幂等：已处理过的 svg 打 data-vl-svg-title-fixed，重复执行不产生新 id。
 */
(function () {
  'use strict';

  var MARK = 'data-vl-svg-title-fixed';
  var counter = 0;

  function fix(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var svgs = scope.querySelectorAll('svg[aria-labelledby~="title"], svg[aria-labelledby="title"]');
    for (var i = 0; i < svgs.length; i += 1) {
      var svg = svgs[i];
      if (svg.hasAttribute(MARK)) continue;
      var title = svg.querySelector('title[id="title"]');
      if (!title) continue;
      counter += 1;
      var unique = 'vl-svg-title-' + counter;
      title.id = unique;
      svg.setAttribute('aria-labelledby', unique);
      svg.setAttribute(MARK, '');
    }
  }

  function schedule(root) {
    fix(root);
    /* 主题的 AJAX/编辑器插入、以及 A/B 切换后出现的图标 */
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () { fix(root); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(document); }, { once: true });
  } else {
    schedule(document);
  }
  window.addEventListener('load', function () { schedule(document); });
  document.addEventListener('shopify:section:load', function (event) { schedule(event.target || document); });

  /* 动态插入兜底：主题的筛选/分页/抽屉会用 AJAX 替换 DOM */
  if (window.MutationObserver) {
    var timer = null;
    new MutationObserver(function () {
      if (timer) return;
      timer = window.setTimeout(function () { timer = null; schedule(document); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
